import { DrawingColor } from "common/interfaces/DrawingColor";

// 洪水浸水想定区域カラーチャート
export const shinsuiColors: DrawingColor[] = [
  {
    code: 3,
    name: "0.0〜0.5m",
    strokeColor: "#cccccc",
    fillColor: "#f4e2ad",
    blueFillColor: "#e3f2fd"
  },
  {
    code: 4,
    name: "0.5〜3.0m",
    strokeColor: "#cccccc",
    fillColor: "#f9d9c3",
    blueFillColor: "#bbdefb"
  },
  {
    code: 5,
    name: "3.0〜5.0m",
    strokeColor: "#cccccc",
    fillColor: "#f4bab9",
    blueFillColor: "#64b5f6"
  },
  {
    code: 6,
    name: "5.0〜10m",
    strokeColor: "#cccccc",
    fillColor: "#f09694",
    blueFillColor: "#2196f3"
  },
  {
    code: 7,
    name: "10〜20m",
    strokeColor: "#cccccc",
    fillColor: "#e38bc6",
    blueFillColor: "#1976d2"
  },
  {
    code: 8,
    name: "20m〜",
    strokeColor: "#cccccc",
    fillColor: "#cf7fb9",
    blueFillColor: "#0d47a1"
  }
];

export const originalShinsuiColors = [
  { r: 244, g: 226, b: 173 }, // 0.0〜0.5m
  { r: 249, g: 217, b: 195 }, // 0.5〜3.0m
  { r: 244, g: 186, b: 185 }, // 3.0〜5.0m
  { r: 240, g: 150, b: 148 }, // 5.0〜10m
  { r: 227, g: 139, b: 198 }, // 10〜20m
  { r: 207, g: 127, b: 185 } // 20m〜
];

export const blueShinsuiColors = [
  { r: 227, g: 242, b: 253 }, // 0.0〜0.5m
  { r: 187, g: 222, b: 251 }, // 0.5〜3.0m
  { r: 100, g: 181, b: 246 }, // 3.0〜5.0m
  { r: 33, g: 150, b: 243 }, // 5.0〜10m
  { r: 25, g: 118, b: 210 }, // 10〜20m
  { r: 13, g: 71, b: 161 } // 20m〜
];
